// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__Drwnv","header":"MessagesList_header__3nuo2","chat":"MessagesList_chat__k6Xwk"};